<template>
  <ten-popup
    trigger-type="manual"
    direction="bottom left"
    :show="popupShow"
    :width="popupWidthHandler"
    :destroy="false"
    @change="popupShow = false"
  >
    <template v-slot:trigger>
      <ten-input
        class="ten-auto-complete"
        v-bind="$attrs"
        v-on="_listeners"
        :value="value"
        :get-input="getInput"
        :autocomplete="false"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
        @click.stop="onTriggerClick"
      >
        <template
          v-for="name in inputSlotName"
          v-slot:[name]
        >
          <!-- @slot @ignore -->
          <slot :name="name" />
        </template>
      </ten-input>
    </template>

    <template>
      <ten-options ref="refOptions">
        <ten-option
          v-for="(option, i) in options"
          :key="i"
          :selected="value === option"
          @optionClick="onOptionClick(option)"
          @optionKeyCommand="c => onOptionKeyCommand(option, c)"
        >
          <template v-if="renderOption">
            <render-cell
              :render="renderOption"
              :option="option"
              :value="value"
            />
          </template>
          <template v-else>
            {{ option }}
          </template>
        </ten-option>
      </ten-options>
    </template>
  </ten-popup>
</template>

<script>
import TenPopup from '../popup';
import TenInput from '../input';
import RenderCell from '../render-cell';
import TenOptions from '../cascader-panel/options';
import TenOption from '../cascader-panel/option';

const name = 'ten-auto-complete';
export default {
  name,
  components: {
    TenPopup,
    TenInput,
    RenderCell,
    TenOptions,
    TenOption,
  },
  props: {
    /**
     * @model
     *
     * 值
     */
    value: {
      type: String,
    },
    /**
     * 默认值
     */
    defaultValue: {
      type: String,
    },
    /**
     * 自动填充数据源
     */
    dataSource: {
      type: Array,
      default: () => [],
    },
    /**
     * 当dataSource为对象数组时，指定选项数据的字段
     */
    optionValue: {
      type: String,
      default: 'value',
    },
    /**
     * 选项的render函数
     */
    renderOption: {
      type: Function,
    },
  },
  data() {
    return {
      popupShow: false,
      focused: false,
    };
  },
  computed: {
    options() {
      return this.dataSource.map((v) => {
        if (v && typeof v === 'object') {
          v = v[this.optionValue];
        }

        return v;
      }).filter(v => (
        !this.value
        || (this.value && v.indexOf(this.value) > -1)
      ));
    },
    _listeners() {
      const { change, input, focus, blur, click, select, ...others } = this.$listeners;
      return others;
    },
    inputSlotName() {
      return Object.keys(this.$scopedSlots);
    },
  },
  watch: {
    value: {
      handler() {
        if (!this.options.length) {
          this.popupShow = false;
        } else if (!this.popupShow) {
          this.popupShow = true;
        }
      },
    },
    popupShow: {
      handler(value) {
        if (value) {
          this.$refs.refOptions && this.$refs.refOptions.focus();
        }
      },
    },
  },
  methods: {
    popupWidthHandler(input) {
      return input.offsetWidth;
    },
    onInput(value) {
      /**
       * value值改变后触发的事件
       */
      this.$emit('change', value);
      /**
       * 输入触发的事件
       */
      this.$emit('search', value);
    },
    onFocus(e) {
      if (!this.focused) {
        /**
         * 聚焦事件
         */
        this.$emit('focus', e);
      }
      this.focused = true;
      this.isBluring = false;
    },
    onBlur(e) {
      this.isBluring = true;
      setTimeout(() => {
        if (this.isBluring) {
          this.focused = false;
          this.popupShow = false;
          /**
           * 失焦事件
           */
          this.$emit('blur', e);
        }
      }, 300);
    },
    onOptionClick(value) {
      setTimeout(() => {
        this.popupShow = false;
      });
      this.refInput && this.refInput.focus();
      if (this.value !== value) {
        setTimeout(() => {
          if (this.refInput && typeof this.refInput.value === 'string') {
            this.refInput.selectionEnd = this.refInput.value.length;
            this.refInput.selectionStart = this.refInput.value.length;
          }
        });

        this.$emit('change', value);
      }
      /**
       * 选择选项后触发的事件
       */
      this.$emit('select', value);
    },
    getInput(input) {
      this.refInput = input;
    },
    onTriggerClick() {
      if (this.options.length) this.popupShow = true;
    },
    onOptionKeyCommand(value, command) {
      if (command === 'enter') this.onOptionClick(value);
    },
  },
};
</script>
